import { Stack } from '@mantine/core';
import { TreeSelect } from '@vision/ui/components';
import { ContentCategoryModelSelect } from '@vision/ui/components/ContentCategoryModelSelect/ContentCategoryModelSelect';
import { Status } from '@vision/ui/enums';
import { useSelectedAccountId } from '@vision/ui/hooks';
import { ContentCategory, TreeSelectItemType } from '@vision/ui/interfaces';
import { useGetContentCategoriesQuery } from '@vision/ui/services';
import { useTranslation } from 'react-i18next';
import { getReportDataName } from '../../utils';

type Props = {
  value: string[];
  modelId: string | null;
  onChange: (ids: string[]) => void;
  onModelChange: (id: string | null) => void;
  error?: string;
  required?: boolean;
};

function itemMapper(item: ContentCategory): TreeSelectItemType {
  return {
    children: [],
    disabled: false,
    id: item.id,
    label: getReportDataName(item.name),
    parentId: item.parent_id,
  };
}

export function ContentCategorySelection({ value, modelId, onChange, onModelChange, error, required }: Props) {
  const { t } = useTranslation();
  const accountId = useSelectedAccountId();
  const { currentData: contentCategories, isFetching } = useGetContentCategoriesQuery({
    accountId,
    status: Status.ACTIVE,
    aiModelId: modelId || undefined,
  });

  return (
    <Stack gap="sm">
      <ContentCategoryModelSelect value={modelId} onChange={onModelChange} />
      <TreeSelect
        items={contentCategories ?? []}
        mapper={itemMapper}
        value={value}
        onChange={onChange}
        withDropdown={true}
        inputProps={{
          label: t('contentCategories'),
          error,
          withAsterisk: required,
          placeholder: t('selectContentCategories'),
        }}
        loading={isFetching}
        showSelectedItemsOnTop={false}
        withSubCategories={true}
      />
    </Stack>
  );
}
